<template>
  <div class="pc-chart">
    <div class="pc-chart-header">
      <h1>
        {{selectedChart==1?"月用户活跃度":"月新增用户"}}
        <span>总数:{{ total }}</span>
        <span>占比:{{ Math.ceil(total/userStatisticses.user_count*100) + "%" }}</span>
      </h1>

      <div class="header-function">
        <!-- 时间选项卡 -->
        <div class="header-function-timeTab">
          <button
            :class="{
              active: selectedChart == 1,
            }"
            @click="changeChart(1)"
          >
            活跃度
          </button>
          <button
            :class="{
              active: selectedChart == 2,
            }"
            @click="changeChart(2)"
          >
            用户增量
          </button>
        </div>
      </div>
    </div>

    <!-- Chart 趋势图 -->
    <div ref="myChart" :style="{ width: '100%', height: '240px' }"></div>
  </div>
</template>



<script>
export default {
  props: { userStatisticses: Object },
  data() {
    return {
      selectedChart: 1,
      total: 0,
      // Chart 趋势图
      xAxis: [],
      yAxis: [],
    };
  },
  watch: {
    userStatisticses() {
      this.getData();
      console.log(this.userStatisticses);
    },
  },

  methods: {
    changeChart(data) {
      this.selectedChart = data;
      this.getData();
    },
    getData() {
      this.total = 0
      this.xAxis = [];
      this.yAxis = [];
      let data = [];
      if (this.selectedChart == 1) {
        for (let key in this.userStatisticses.activate_data) {
          this.total += this.userStatisticses.activate_data[key]
          data.push({
            date: key,
            val: this.userStatisticses.activate_data[key],
          });
        }
      } else {
        for (let key in this.userStatisticses.new_user_data) {
          this.total += this.userStatisticses.new_user_data[key]
          data.push({
            date: key,
            val: this.userStatisticses.new_user_data[key],
          });
        }
      }
      data = data.sort((a,b)=>{return (new Date(a.date)).getTime() - (new Date(b.date)).getTime()})
      data.forEach((item)=>{
        this.xAxis.push(item.date)
        this.yAxis.push(item.val)
      })
      console.log(data,this.xAxis)

      this.drawChart();
    },

    drawChart() {
      let myChart = this.$echarts.init(this.$refs.myChart);
      console.log(myChart);
      // 绘制图表
      myChart.setOption({
        color: ["#CAE6FF", "#FFEDC3"],
        title: {
          // text: '浏览趋势'
        },
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "axis",
          // formatter: "{b}: {c}\n ({d}%)",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        legend: {
          data: [`${this.selectedChart == 2 ? "月新增" : "月活跃度"}`],
        },
        //  legend: {
        //   data: ["访问量", "历史访问量"],
        // },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            // 导出图片
            // saveAsImage: {},
            // 数据视图
            // dataView: {},
            // 重置
            // restore: {},
            // 区域缩放
            // dataZoom: {},
            // 动态图表类型的切换
            // magicType: {
            //   type: ['bar', 'line']
            // }
          },
        },
        xAxis: {
          type: "category",
          //  boundaryGap: false,
          data: this.xAxis,
          axisLabel: {
            showMaxLabel: true,
            //  rotate:40
          },
          boundaryGap: true,
          // data: [
          //   "0:00",
          //   "1:00",
          //   "2:00",
          //   "3:00",
          //   "4:00",
          //   "5:00",
          //   "6:00",
          //   "7:00",
          //   "8:00",
          //   "9:00",
          //   "10:00",
          //   "11:00",
          //   "12:00",
          //   "13:00",
          //   "14:00",
          //   "15:00",
          //   "16:00",
          //   "17:00",
          //   "18:00",
          //   "19:00",
          //   "20:00",
          //   "21:00",
          //   "22:00",
          //   "23:00",
          // ],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: `${this.selectedChart == 2 ? "月新增" : "月活跃度"}`,
            // data: ["820", "932", "901", "934", "1290", "1330", "1320"],
            data: this.yAxis,
            type: "line",
            smooth: true,
            // symbol: 'none',
            itemStyle: {
              color: "#4867BC",
              width: 0,
            },

            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#CAE6FF",
                },
                {
                  offset: 1,
                  color: "#fff",
                },
              ]),
            },
          },
        ],
      });
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-chart {
  overflow: hidden;
  min-width: 670px;
  height: 400px;
  border-radius: 4px;
  padding: 40px 15px 0 15px;
  box-shadow: $boxshadow;
  .pc-chart-header {
    position: relative;
    border-bottom: 1px solid $border-color;
    padding-bottom: 20px;
    margin-bottom: 40px;
    flex-wrap: nowrap;
    justify-content: space-between;
    .device-choose {
      position: absolute;
      top: 5px;
      left: 100px;
      display: flex;
      p {
        cursor: pointer;
        font-size: 12px;
        line-height: 20px;
        padding: 0px 10px;
        margin-right: 10px;
        border: 1px solid $timeBtn;
        border-radius: 10px;
      }
      p:hover {
        background: $timeBtn;
        color: $base-color;
      }
      .choosed {
        background: $timeBtn;
        color: $base-color;
      }
    }
    h1 {
      position: relative;
      color: $mainTitle;
      font-size: 20px;
      align-self: center;
      word-break: keep-all;
      display: inline-block;
      vertical-align: top;
      span {
        top: 70px;
        position: absolute;
        font-size: 16px;
        left: 27px;
      }
      span:nth-of-type(2) {
        position: absolute;
        left: 130px;
      }
    }
    .header-function {
      transform: translateY(-23%);
      float: right;
      display: flex;
      /deep/ .el-radio-button__inner {
        padding: 12px 15px;
      }
      /deep/ .el-radio-group {
        margin-right: 13px;
      }
      /deep/ .el-range-separator {
        min-width: 28px;
        font-family: $chinese;
        font-size: 13.8px;
        color: $thirdTitle;
        transform: translateY(-0.5px);
      }
      /deep/ .el-input__icon.el-range__close-icon {
        display: none;
      }
      // /deep/ .el-input__icon {
      //   transform: translateX(201px) scale(1.3);
      // }
      // /deep/ .el-range-input,
      // /deep/ .el-range-separator {
      //   transform: translateX(-24px);
      // }
      .header-function-timeTab {
        font-size: 0;
        margin-right: 15px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        height: 40px;
        overflow: hidden;
        button {
          height: 100%;
          outline: unset;
          padding: 0 14px;
          background: none;
          cursor: pointer;
          border: none;
          font-family: $chinese;
          font-size: 13.8px;
          font-weight: 400;
          color: $thirdTitle;
          &:hover {
            color: $timeBtn;
            filter: brightness(110%);
          }
          &:active {
            filter: brightness(110%);
          }
        }
        button:nth-child(1),
        button:nth-child(2),
        button:nth-child(3) {
          border-right: 1px solid #dcdfe6;
        }
        .active {
          background: #5470c6 !important;
          color: white !important;
        }
      }
    }
  }
  // .datepicker {
  //   /deep/ input:focus::placeholder {
  //     color: transparent;
  //   }
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userList/ChartUserVitality.vue